import React from "react";
import { FaArrowLeft } from "react-icons/fa";
import "../../styles/components/AppBackButton.css";

export default function AppBackButton({
  label,
  onClick,
  className = "",
  type = "button",
  disabled = false,
  ariaLabel,
}) {
  const classes = ["app-back-button", className].filter(Boolean).join(" ");

  return (
    <button
      type={type}
      className={classes}
      onClick={onClick}
      disabled={disabled}
      aria-label={ariaLabel || label}
    >
      <span className="app-back-button__icon" aria-hidden="true">
        <FaArrowLeft className="app-back-button__icon-svg" />
      </span>
      <span className="app-back-button__label">{label}</span>
    </button>
  );
}
